"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateRange = exports.getDaysInFuture = exports.processSearchParticipantsResponse = exports.processMembersResponse = exports.convertTimeToMsWithTimeUnit = exports.validateEndTime = exports.validateEndDate = exports.rangeToDateTime = exports.rangeToDate = exports.validatePhoneNumber = exports.createLink = exports.createDisabledRange = exports.getPhoneField = exports.getLocationField = exports.getDefaultFields = exports.getAvailabilityData = exports.transformMember = exports.transformHost = exports.convertFromLocationTypeToSchedulerLocationTab = exports.convertToServiceDataRequestLocationTypeEnum = exports.convertToAppointmentSaveRequestLocationTypeEnum = exports.convertToInviteSaveRequestLocationTypeEnum = exports.convertToAvailabilityOption = exports.filterMembers = exports.filterDuplicateMeetings = exports.makeActionCreator = void 0;
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const generated_api_1 = require("@/app/SUMOCEP/server/generated-api");
const moment_1 = __importDefault(require("moment"));
const uuid_1 = require("uuid");
function makeActionCreator(type) {
    return (payload) => ({ type, payload });
}
exports.makeActionCreator = makeActionCreator;
const filterDuplicateMeetings = (meetings) => {
    if (!meetings.length)
        return [];
    const seen = new Set();
    return meetings.filter(({ title, startsAt, finishesAt }) => {
        const key = `${title}-${startsAt}-${finishesAt}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
};
exports.filterDuplicateMeetings = filterDuplicateMeetings;
const filterMembers = (members = [], host, mainGuest, guests) => {
    const membersMap = new Map();
    const fullMembersList = [...members, ...(mainGuest ? [mainGuest] : []), ...guests];
    for (const newMember of fullMembersList) {
        const { email } = newMember;
        if (!email)
            continue;
        if ((0, helpers_1.isSameEmail)(email, host?.email))
            continue;
        const currentMember = membersMap.get(email);
        const isSumo1 = currentMember?.type === "SUMO1" /* MemberType.SUMO1 */;
        const isOldSalesforce = currentMember?.type === "SALESFORCE" /* MemberType.SALESFORCE */ && currentMember?.subType === "LEAD" /* MemberSubType.LEAD */;
        const isNewSalesforceCEP = newMember?.type === "SALESFORCE" /* MemberType.SALESFORCE */ && newMember?.subType === "USER" /* MemberSubType.USER */;
        if (isSumo1)
            continue;
        if (isOldSalesforce && !isNewSalesforceCEP)
            continue;
        membersMap.set(email, newMember);
    }
    return Array.from(membersMap.values());
};
exports.filterMembers = filterMembers;
const convertToAvailabilityOption = (availability) => {
    const list = {
        ["OPEN" /* SchedulerAvailability.OPEN */]: generated_api_1.InviteSaveRequestAvailabilityOptionEnum.OPEN,
        ["CUSTOM" /* SchedulerAvailability.CUSTOM */]: generated_api_1.InviteSaveRequestAvailabilityOptionEnum.CUSTOM,
        ["ROLLING" /* SchedulerAvailability.ROLLING */]: generated_api_1.InviteSaveRequestAvailabilityOptionEnum.ROLLING_WINDOW,
        ["RANGE" /* SchedulerAvailability.RANGE */]: generated_api_1.InviteSaveRequestAvailabilityOptionEnum.DATE_RANGE,
        // [SchedulerAvailability.TRAVEL_TIME_GAP]: InviteSaveRequestAvailabilityOptionEnum.TRAVEL_TIME_GAP,
    };
    return list[availability ?? "OPEN" /* SchedulerAvailability.OPEN */];
};
exports.convertToAvailabilityOption = convertToAvailabilityOption;
const convertToInviteSaveRequestLocationTypeEnum = (locationType, fallback = "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */) => {
    const list = {
        ["VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */]: generated_api_1.InviteSaveRequestLocationTypeEnum.VID_CONFERENCE,
        ["PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */]: generated_api_1.InviteSaveRequestLocationTypeEnum.PHONE,
        ["IN_PERSON" /* SchedulerLocationTab.IN_PERSON */]: generated_api_1.InviteSaveRequestLocationTypeEnum.IN_PERSON,
    };
    return list[locationType ?? fallback];
};
exports.convertToInviteSaveRequestLocationTypeEnum = convertToInviteSaveRequestLocationTypeEnum;
const convertToAppointmentSaveRequestLocationTypeEnum = (locationType, fallback = "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */) => {
    const list = {
        ["VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */]: generated_api_1.AppointmentSaveRequestLocationTypeEnum.VID_CONFERENCE,
        ["PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */]: generated_api_1.AppointmentSaveRequestLocationTypeEnum.PHONE,
        ["IN_PERSON" /* SchedulerLocationTab.IN_PERSON */]: generated_api_1.AppointmentSaveRequestLocationTypeEnum.IN_PERSON,
    };
    return list[locationType ?? fallback];
};
exports.convertToAppointmentSaveRequestLocationTypeEnum = convertToAppointmentSaveRequestLocationTypeEnum;
const convertToServiceDataRequestLocationTypeEnum = (locationType, fallback = "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */) => {
    const list = {
        ["VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */]: generated_api_1.ServiceDataRequestLocationTypeEnum.VID_CONFERENCE,
        ["PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */]: generated_api_1.ServiceDataRequestLocationTypeEnum.PHONE,
        ["IN_PERSON" /* SchedulerLocationTab.IN_PERSON */]: generated_api_1.ServiceDataRequestLocationTypeEnum.IN_PERSON,
    };
    return list[locationType ?? fallback];
};
exports.convertToServiceDataRequestLocationTypeEnum = convertToServiceDataRequestLocationTypeEnum;
const convertFromLocationTypeToSchedulerLocationTab = (locationType, fallback = constants_1.LocationPlaceType.VID_CONFERENCE) => {
    const list = {
        [constants_1.LocationPlaceType.VID_CONFERENCE]: "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */,
        [constants_1.LocationPlaceType.VIRTUAL_EVENT]: "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */,
        [constants_1.LocationPlaceType.PHONE]: "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */,
        [constants_1.LocationPlaceType.PHONE_INBOUND]: "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */,
        [constants_1.LocationPlaceType.IN_PERSON]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
        [constants_1.LocationPlaceType.OUR_LOCATION]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
        [constants_1.LocationPlaceType.IN_HOUSE]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
        [constants_1.LocationPlaceType.OFFICE]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
        [constants_1.LocationPlaceType.LOCATION]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
        [constants_1.LocationPlaceType.GOOGLE_LOCATION]: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
    };
    return list[locationType ?? fallback];
};
exports.convertFromLocationTypeToSchedulerLocationTab = convertFromLocationTypeToSchedulerLocationTab;
const transformHost = (host) => ({
    id: host?.id,
    email: host?.email,
    name: host?.name,
    type: "SUMO1" /* MemberType.SUMO1 */,
    subType: host?.subType,
});
exports.transformHost = transformHost;
const transformMember = (member) => {
    if (!member)
        return undefined;
    return {
        id: member.id,
        email: member.email,
        name: member.name,
        type: member.type,
        subType: member.subType,
    };
};
exports.transformMember = transformMember;
const getAvailabilityData = (availability, availabilityCustom, availabilityRange, availabilityRollingWindow, availabilityRollingExpiration) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */: {
            return {};
        }
        case "CUSTOM" /* SchedulerAvailability.CUSTOM */: {
            return {
                customRanges: availabilityCustom,
            };
        }
        case "RANGE" /* SchedulerAvailability.RANGE */: {
            const from = new Date();
            const to = new Date();
            // Set from and to dates
            if (availabilityRange.startDate) {
                from.setDate(availabilityRange.startDate[0]);
                from.setMonth(availabilityRange.startDate[1]);
                from.setFullYear(availabilityRange.startDate[2]);
            }
            if (availabilityRange.endDate) {
                to.setDate(availabilityRange.endDate[0]);
                to.setMonth(availabilityRange.endDate[1]);
                to.setFullYear(availabilityRange.endDate[2]);
            }
            // Set from and to times
            if (availabilityRange.startTime) {
                from.setHours(availabilityRange.startTime[0], availabilityRange.startTime[1], 0, 0);
            }
            if (availabilityRange.endTime) {
                to.setHours(availabilityRange.endTime[0], availabilityRange.endTime[1], 0, 0);
            }
            // Generate daily custom ranges within date range
            const customRanges = [];
            for (let current = new Date(from); current < to; current.setDate(current.getDate() + 1)) {
                const dailyFrom = new Date(current);
                const dailyTo = new Date(current);
                if (availabilityRange.startTime) {
                    dailyFrom.setHours(availabilityRange.startTime[0], availabilityRange.startTime[1], 0, 0);
                }
                if (availabilityRange.endTime) {
                    dailyTo.setHours(availabilityRange.endTime[0], availabilityRange.endTime[1], 0, 0);
                }
                customRanges.push({
                    start: dailyFrom.toISOString(),
                    end: dailyTo.toISOString(),
                });
            }
            return { customRanges };
        }
        case "ROLLING" /* SchedulerAvailability.ROLLING */: {
            let expiresAt = null;
            if (availabilityRollingExpiration) {
                const date = new Date();
                date.setDate(availabilityRollingExpiration[0]);
                date.setMonth(availabilityRollingExpiration[1]);
                date.setFullYear(availabilityRollingExpiration[2]);
                expiresAt = date.toISOString();
            }
            return {
                rollingWindowDays: availabilityRollingWindow,
                expiresAt,
            };
        }
        default: {
            return {};
        }
    }
};
exports.getAvailabilityData = getAvailabilityData;
const getDefaultFields = (name, email, hasCustomRequiredFields) => [
    {
        id: (0, uuid_1.v4)(),
        answers: [],
        enabled: true,
        label: 'Full Name',
        required: true,
        type: "TEXT" /* InputFieldType.TEXT */,
        fieldType: "NAME" /* InputFieldFieldType.NAME */,
        value: hasCustomRequiredFields ? name : name || email, // fill empty name with email only if no other input required
    },
    {
        id: (0, uuid_1.v4)(),
        answers: [],
        enabled: true,
        label: 'Email',
        required: true,
        type: "TEXT" /* InputFieldType.TEXT */,
        fieldType: "EMAIL" /* InputFieldFieldType.EMAIL */,
        value: email,
    },
];
exports.getDefaultFields = getDefaultFields;
const getLocationField = () => ({
    id: (0, uuid_1.v4)(),
    answers: [],
    enabled: true,
    label: 'Location',
    required: true,
    type: "TEXT" /* InputFieldType.TEXT */,
    fieldType: "LOCATION" /* InputFieldFieldType.LOCATION */,
});
exports.getLocationField = getLocationField;
const getPhoneField = () => ({
    id: (0, uuid_1.v4)(),
    answers: [],
    enabled: true,
    label: 'Phone',
    required: true,
    type: "PHONE" /* InputFieldType.PHONE */,
    fieldType: "PHONE" /* InputFieldFieldType.PHONE */,
});
exports.getPhoneField = getPhoneField;
const createDisabledRange = (event = {}, timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
    const defaultEvent = {
        display: 'background',
        borderColor: 'var(--bluegray-200)',
        backgroundColor: 'var(--bluegray-200)',
    };
    return {
        ...defaultEvent,
        ...event,
        type: 'DISABLED_RANGE',
        start: (0, moment_1.default)(event.start).tz(timeZone).format('YYYY-MM-DDTHH:mm:ssZ'),
        end: (0, moment_1.default)(event.end).tz(timeZone).format('YYYY-MM-DDTHH:mm:ssZ'),
    };
};
exports.createDisabledRange = createDisabledRange;
const createLink = ({ bookingPageId, spot }) => {
    return helpers_1.query.set(`${SUMO1_APPLICATION_ORIGIN}/book/${bookingPageId}`, { source: 'inbox', spot });
};
exports.createLink = createLink;
const validatePhoneNumber = (phoneNumber) => {
    const phoneLength = phoneNumber?.replace(/-/g, '').length || 0;
    return phoneLength >= 4 && phoneLength <= 16;
};
exports.validatePhoneNumber = validatePhoneNumber;
const rangeToDate = (range) => {
    if (range) {
        const date = new Date();
        date.setDate(range[0]);
        date.setMonth(range[1]);
        date.setFullYear(range[2]);
        return date;
    }
    return undefined;
};
exports.rangeToDate = rangeToDate;
const rangeToDateTime = (date, time) => {
    if (!date || !time) {
        return undefined;
    }
    const dateTime = new Date();
    dateTime.setDate(date[0]);
    dateTime.setMonth(date[1]);
    dateTime.setFullYear(date[2]);
    dateTime.setHours(time[0]);
    dateTime.setMinutes(time[1]);
    return dateTime;
};
exports.rangeToDateTime = rangeToDateTime;
const validateEndDate = (startDate, endDate) => {
    const start = (0, exports.rangeToDate)(startDate);
    const end = (0, exports.rangeToDate)(endDate);
    return Boolean(start && end && end.getTime() >= start.getTime());
};
exports.validateEndDate = validateEndDate;
const validateEndTime = (startDate, startTime, endDate, endTime) => {
    const start = (0, exports.rangeToDateTime)(startDate, startTime);
    const end = (0, exports.rangeToDateTime)(endDate, endTime);
    return Boolean(start && end && end.getTime() > start.getTime());
};
exports.validateEndTime = validateEndTime;
const convertTimeToMsWithTimeUnit = (duration = 0, timeUnit = constants_1.TimeUnit.MINUTE) => {
    if (!duration || !timeUnit)
        return 0;
    switch (timeUnit) {
        case constants_1.TimeUnit.MINUTE:
            return duration * helpers_1.time.minute;
        case constants_1.TimeUnit.HOUR:
            return duration * helpers_1.time.hour;
        case constants_1.TimeUnit.DAY:
            return duration * helpers_1.time.day;
        default:
            throw new Error('Invalid time unit');
    }
};
exports.convertTimeToMsWithTimeUnit = convertTimeToMsWithTimeUnit;
const getGuest = (contact, members, params) => {
    const foundMainGuest = members?.find((member) => (0, helpers_1.isSameEmail)(member.email, contact?.emailAddress));
    const guest = foundMainGuest || {
        id: (0, uuid_1.v4)(),
        type: "CUSTOM" /* MemberType.CUSTOM */,
        subType: "CONTACT" /* MemberSubType.CONTACT */,
        email: contact?.emailAddress,
        name: contact?.name,
    };
    return guest;
};
const processMembersResponse = (membersList, params) => {
    const members = membersList.map((member) => {
        if (member.type === "SUMO1" /* MemberType.SUMO1 */ && member.subType) {
            return member;
        }
        return {
            ...member,
            integration: (0, helpers_1.getIntegration)(member),
            subType: "CONTACT" /* MemberSubType.CONTACT */,
        };
    });
    const { TO = [], CC = [], BCC = [] } = params.recipientsEmails || {};
    const contacts = [...TO, ...CC, ...BCC];
    if (!contacts.length) {
        return {
            members,
            mainGuest: null,
            guests: [],
        };
    }
    const emails = contacts.map((g) => g.emailAddress);
    const uniqueEmails = Array.from(new Set(emails));
    const uniqueGuests = uniqueEmails.map((email) => contacts.find((guest) => guest.emailAddress === email));
    const [first, ...other] = uniqueGuests;
    const mainGuest = getGuest(first, members, params);
    const guests = other.map((contact) => getGuest(contact, members, params));
    const uniqueMembers = members.filter((member) => ![mainGuest, ...guests].some((prevMember) => prevMember.id === member.id));
    return {
        members: [mainGuest, ...guests, ...uniqueMembers],
        mainGuest,
        guests,
    };
};
exports.processMembersResponse = processMembersResponse;
const processSearchParticipantsResponse = (contacts, searchResults) => {
    const emails = contacts.map((c) => c.emailAddress);
    const uniqueEmails = Array.from(new Set(emails));
    const uniqueContacts = uniqueEmails.map((email) => contacts.find((c) => c.emailAddress === email)).filter((c) => !!c);
    if (!uniqueContacts.length) {
        return { mainGuest: null, guests: [] };
    }
    const resultMap = new Map(searchResults.map((r) => [r.email.toLowerCase(), r.participant]));
    const buildGuest = (contact) => {
        const participant = resultMap.get(contact.emailAddress.toLowerCase());
        if (participant?.value) {
            return {
                id: participant.value,
                type: "SUMO1" /* MemberType.SUMO1 */,
                subType: participant.type?.toUpperCase() || "CONTACT" /* MemberSubType.CONTACT */,
                email: contact.emailAddress,
                name: participant.label || contact.name,
            };
        }
        return {
            id: (0, uuid_1.v4)(),
            type: "CUSTOM" /* MemberType.CUSTOM */,
            subType: "CONTACT" /* MemberSubType.CONTACT */,
            email: contact.emailAddress,
            name: contact.name,
        };
    };
    const [first, ...other] = uniqueContacts;
    if (!first) {
        return { mainGuest: null, guests: [] };
    }
    const mainGuest = buildGuest(first);
    const guests = other.map(buildGuest);
    return { mainGuest, guests };
};
exports.processSearchParticipantsResponse = processSearchParticipantsResponse;
const getDaysInFuture = (calendarFinishAt) => {
    const diffMillis = calendarFinishAt - Date.now();
    return Math.ceil(diffMillis / (1000 * 60 * 60 * 24));
};
exports.getDaysInFuture = getDaysInFuture;
const getDateRange = ({ availability, availabilityRollingWindow, calendarFinishAt, availabilityRange, }) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */:
            return {
                type: "DAYS_IN_FUTURE" /* SUMOCEP_server.DateRangeType.DAYS_IN_FUTURE */,
                count: Math.max(30, (0, exports.getDaysInFuture)(calendarFinishAt)),
            };
        case "ROLLING" /* SchedulerAvailability.ROLLING */:
            return {
                type: "DAYS_IN_FUTURE" /* SUMOCEP_server.DateRangeType.DAYS_IN_FUTURE */,
                count: availabilityRollingWindow,
            };
        case "RANGE" /* SchedulerAvailability.RANGE */:
            return {
                type: "RANGE" /* SUMOCEP_server.DateRangeType.RANGE */,
                from: (0, exports.rangeToDate)(availabilityRange.startDate)?.toISOString(),
                to: (0, exports.rangeToDate)(availabilityRange.endDate)?.toISOString(),
            };
        default:
            return {
                type: "UNLIMITED" /* SUMOCEP_server.DateRangeType.UNLIMITED */,
            };
    }
};
exports.getDateRange = getDateRange;
